module.exports = __webpack_public_path__ + "img/arrow-right_s.71d0995c.svg";